import React, { useEffect, useRef } from "react";
import { useIntl } from "react-intl";
import { Formik, useFormikContext } from "formik";
import Form from "@components/common/form";
import { ToggleLink } from "../toggle-link";
import messages from "../messages.i18n";
import { useManualEntryFormFields, useManualEntryFormValidationSchema, ManualEntryFormInitialValues, } from "./ManualEntryFormConfig";
const FormValuesWatcher = ({ onSelect }) => {
    const { values, isValid } = useFormikContext();
    const prevResultRef = useRef("");
    useEffect(() => {
        var _a;
        const address = ((_a = values.communityAddress) === null || _a === void 0 ? void 0 : _a.description) || "";
        let result = null;
        if (isValid && values.communityName && address && values.communityWebsite) {
            result = {
                name: values.communityName,
                address,
                website: values.communityWebsite,
            };
        }
        const resultKey = result ? `${result.name}|${result.address}|${result.website}` : "";
        if (resultKey !== prevResultRef.current) {
            prevResultRef.current = resultKey;
            onSelect(result);
        }
    }, [values, isValid, onSelect]);
    return null;
};
export const ManualEntryForm = ({ onSelect, onRevertToSearch }) => {
    const intl = useIntl();
    const formFields = useManualEntryFormFields();
    const validationSchema = useManualEntryFormValidationSchema();
    return (React.createElement(Formik, { initialValues: ManualEntryFormInitialValues, validationSchema: validationSchema, validateOnChange: true, validateOnBlur: true, onSubmit: () => { } },
        React.createElement(React.Fragment, null,
            React.createElement(FormValuesWatcher, { onSelect: onSelect }),
            React.createElement(Form, { formFields: formFields, submitText: "" }),
            React.createElement(ToggleLink, { prefixText: intl.formatMessage(messages.revertToSearch), linkText: intl.formatMessage(messages.searchAndSelect), onClick: onRevertToSearch }))));
};
export default ManualEntryForm;
